import { apiSlice } from '../api/api-slice';
import { AddStaffInfoRequest } from 'types/add-staff-user/add-staff-info';

export const adminCreatStaff = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        addStaff: builder.mutation<void, AddStaffInfoRequest>({
            query: (addStaffInfoRequest: AddStaffInfoRequest) => ({
                url: '/admin/add-staff-user',
                method: 'POST',
                body: { ...addStaffInfoRequest },
            }),
        }),
    }),
});
export const { useAddStaffMutation } = adminCreatStaff;
